import { render, staticRenderFns } from "./CoreCompetitiveness.vue?vue&type=template&id=66ae5d35&scoped=true&"
import script from "./CoreCompetitiveness.vue?vue&type=script&lang=js&"
export * from "./CoreCompetitiveness.vue?vue&type=script&lang=js&"
import style0 from "./CoreCompetitiveness.vue?vue&type=style&index=0&id=66ae5d35&lang=stylus&scoped=true&"
import style1 from "./CoreCompetitiveness.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae5d35",
  null
  
)

export default component.exports